export default {"src":"/_next/static/media/bg-cta.00feb0b4.svg","height":568,"width":1280,"blurWidth":0,"blurHeight":0};